import cvScreen from '../Assets/cv_screen.png';
import aikidoScreen from '../Assets/aikido_screen.png';
import diceScreen from '../Assets/dice_screen.png';
import donjonScreen from '../Assets/donjon_screen.png';
import goyaveScreen from '../Assets/goyave_screen.png';
import quaiAntiqueScreen from '../Assets/quai-antique_screen.png';
import spyScreen from '../Assets/spy_screen.png';
import folioScreen from '../Assets/folio_screen.png'
import tattooScreen from '../Assets/tattoo_screen.png'
import mahjongScreen from '../Assets/mahjong_screen.png'

const images = {
  cvScreen,
  aikidoScreen,
  diceScreen,
  donjonScreen,
  goyaveScreen,
  quaiAntiqueScreen,
  spyScreen,
  folioScreen,
  tattooScreen,
  mahjongScreen,
};

export default images;